import { createContext, useContext } from 'react';

export const CurrentNoteContextData = createContext({
  typeOfNotes: {},
  componentRefs: {},
  virtuosoRef: null,
  initialIndex: 0
});
export const useCurrentNoteContextData = () => useContext(CurrentNoteContextData);

export const CurrentNoteContextApi = createContext({
  getClinicalNoteForms: () => {},
  scrollToForm: () => {},
  setInitialIndex: () => {}
});
export const useCurrentNoteContextApi = () => useContext(CurrentNoteContextApi);
